export const stats = {
  table: {
    field: {
      campaign: 'Campaign',
      campaign_id: 'Campaign ID',
      task_number: 'Task number',
      src: 'Caller ID',
      dst: 'Number',
      date_time: 'Date and time',
      duration: 'Duration',
      cost: 'Cost',
      status: 'Status',
      task_id: 'Task ID',
      call_date: 'Started at',
      progress_date: 'Initialized at',
      answer_date: 'Answered at',
      connection_date: 'Connected to operator at',
      end_date: 'Call ended at',
      recording: 'Call recording',
      hangup_cause: 'Hangup Cause Code',
      queue_time: 'Duration of delay after dialing a number',
      pdd: "Duration of waiting for the operator's response",
      duration_billed: 'Duration of conversation',
      campaign_name: 'Campaign',
      type: 'Answering machine type',
      disconnection: 'Disconnection',
      amd_result: 'Probability'
    }
  },

  filter: {
    campaign_name: 'Campaign',
    status: '@:autocaller_v2.stats.table.field.status',
    task_number: '@:autocaller_v2.stats.table.field.task_number',
    src: '@:autocaller_v2.stats.table.field.src',
    dst: '@:autocaller_v2.stats.table.field.dst'
  },

  state: {
    ANSWERED: 'Answered',
    NO_ANSWER: 'Unanswered',
    REJECTED: 'Rejected',
    ERROR: 'Failed'
  }
};
